import { connect } from 'react-redux';

import ExhibitionContainer from './exhibitionContainer';

const mapStateToProps = state => ({
  data: state.app.pageData.myExhibition
});

export default connect(mapStateToProps)(ExhibitionContainer);
